import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 24,
	viewBox: "0 0 44 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 43,
			height: 23,
			rx: 3.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.1126 8.26058L15.971 15.7571H13.9205L12.3756 9.77506C12.2805 9.40616 12.1992 9.27191 11.914 9.11525C11.4469 8.86269 10.6785 8.62578 10 8.47822L10.0475 8.26063H13.3465C13.7672 8.26063 14.1455 8.54127 14.2406 9.02506L15.0575 13.3639L17.0752 8.26063H19.1126V8.26058ZM27.1445 13.3085C27.1536 11.331 24.4082 11.2234 24.428 10.3387C24.4333 10.0686 24.6893 9.78289 25.2498 9.71075C25.5281 9.67372 26.2941 9.64658 27.1623 10.0452L27.5026 8.45619C27.0355 8.28664 26.435 8.12427 25.6888 8.12427C23.7721 8.12427 22.4228 9.14375 22.4114 10.6025C22.3989 11.6811 23.3741 12.2831 24.1097 12.6424C24.865 13.01 25.1176 13.2447 25.1149 13.5743C25.11 14.0775 24.5123 14.2974 23.9547 14.3073C22.9795 14.3225 22.4139 14.0437 21.9621 13.8334L21.611 15.4769C22.0635 15.6847 22.9013 15.8651 23.7683 15.8757C25.8054 15.8756 27.1381 14.867 27.1445 13.3085ZM32.206 15.7572H34L32.4346 8.26063H30.7785C30.4063 8.26063 30.0926 8.47766 29.9528 8.81014L27.0446 15.7572H29.0801L29.4842 14.6376H31.9724L32.206 15.7572ZM30.0421 13.1011L31.0633 10.2862L31.6508 13.1011H30.0421ZM21.884 8.26058L20.2795 15.7571H18.3398L19.9447 8.26058H21.884Z",
			fill: "#1A2ADF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 43,
			height: 23,
			rx: 3.5,
			stroke: "#EAEAEA"
		})
	]
});
export default SvgVisa;
